import {Flex} from 'antd';
import {ReactElement} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {RatingStarLine} from '../../../../../../../../layout/rating-star-line/rating-star-line';
import {ReviewHistoryDataType} from '../../../../../../../../service/reviews/reviews-history';
import {
    formatHistoryRatingDisplay,
    parseHistoryRatingValue,
} from '../../../../../../../../service/reviews/reviews-history-helper';

import * as styles from './history-modal.scss';

type PropsType = {
    value: ReviewHistoryDataType['oldValue'];
};

export function HistoryCatalogEditRating(props: PropsType): ReactElement | null {
    const {value} = props;

    const rating = parseHistoryRatingValue(value);

    if (rating === null) {
        return null;
    }

    return (
        <Flex align="center" className={styles.HistoryModal_ratingRow} gap={16} wrap>
            <Text stringKey="REVIEWS__REVIEW_CHANGE_HISTORY__RATING" />
            <RatingStarLine rating={rating} />
            <Text lighter>{formatHistoryRatingDisplay(rating)}</Text>
        </Flex>
    );
}
